import React, { memo, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Loading from 'components/Loading';
import { InsuranceBuyingStepRoute } from '../enums/app-route-path.enum';
import { InsuranceTypes } from '../enums';

function InsurancePaymentRoutesGuard({
  isPriceDataValid,
  type,
  children,
}: {
  type: InsuranceTypes;
  isPriceDataValid: boolean;
  children: React.ReactNode;
}) {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, state } = location;
    // if the route InsuranceBuyingStepRoute.PAYMENT_INFO or InsuranceBuyingStepRoute.CALCULATOR doesn't check
    if (
      pathname.includes(InsuranceBuyingStepRoute.CALCULATOR) ||
      (pathname.includes(InsuranceBuyingStepRoute.PAYMENT_INFO) &&
        state?.paymentInfo?.type === type)
    ) {
      setIsLoading(false);

      return;
    }

    // if the route isn't InsuranceBuyingStepRoute.CALCULATOR and the state isn't available,
    // navigate to the InsuranceBuyingStepRoute.CALCULATOR
    if (
      !pathname.includes(InsuranceBuyingStepRoute.CALCULATOR) &&
      !isPriceDataValid
    ) {
      navigate(InsuranceBuyingStepRoute.CALCULATOR);

      return;
    }

    // if the route is InsuranceBuyingStepRoute.PAYMENT and all states need to be,
    // if one isn't available, navigate to the InsuranceBuyingStepRoute.CALCULATOR
    if (
      pathname.includes(InsuranceBuyingStepRoute.PAYMENT) &&
      (!isPriceDataValid || !state?.personInfo)
    ) {
      navigate(InsuranceBuyingStepRoute.CALCULATOR);

      return;
    }

    setIsLoading(false);
  }, [isPriceDataValid, location, navigate, type]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return isLoading ? <Loading height={300} /> : <>{children}</>;
}

export default memo(InsurancePaymentRoutesGuard);
